import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
import { useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import { Button } from "react-bootstrap";
import Utils from "../../common/manipurCommon/Utils";
import Swal from "sweetalert2";

const CompetitionsReport = () => {

    const [stateList, setStateList] = useState<any[]>([]);
    const [districtList, setDistrictList] = useState<any[]>([]);
    const [cityList, setCityList] = useState<any[]>([]);
    const [centerList, setCenterList] = useState<any[]>([]);
    const [competitionTypeList, setCompetitionTypeList] = useState<any[]>([]);
    const [sportTypeList, setSportTypeList] = useState<any[]>([]);
    const [sportList, setSportList] = useState<any[]>([]);
    const [competitionList, setCompetitionList] = useState<any[]>([]);
    const [stateId, setStateId] = useState("");
    const [districtId, setDistrictId] = useState("");
    const [cityId, setCityId] = useState("");
    const [centerId, setCenterId] = useState("");
    const [competitionTypeId, setCompetitionTypeId] = useState("");
    const [sportTypeId, setSportTypeId] = useState("");
    const [sportId, setSportId] = useState("");
    const [venue, setVenue] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [showTable, setShowTable] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchSports() {
            setIsLoading(true);
            const statesResponse = await func.listGeoCenters();
            setCenterList(Array.isArray(statesResponse) ? statesResponse : [])
            const compResponse = await func.competitionType(null);
            setCompetitionTypeList(Array.isArray(compResponse) ? compResponse : [])
            setIsLoading(false);
        }
        fetchSports();
    }, [])

    const filteredData = competitionList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const sportTypeNameRender = (rowData) => {
        return <span>{rowData.SportTypeName}</span>
    };

    const competitionTypeNameRender = (rowData) => {
        return <span>{rowData.competitionTypeName}</span>
    };

    const competitionNameRender = (rowData) => {
        return <span>{rowData.competitionName}</span>
    };

    const venueRender = (rowData) => {
        return <span>{rowData.venue}</span>
    };

    const startDateRender = (rowData) => {
        return <span>{formatDate(rowData.startDate)}</span>
    };

    const endDateRender = (rowData) => {
        return <span>{formatDate(rowData.endDate)}</span>
    };

    const sportNameRender = (rowData) => {
        return <span>{rowData.sportName}</span>
    };

    function competitionsReport() {
        const compRpt = api.CompetitionReport + '/' + competitionTypeId + '/' + sportId + '/' + sportTypeId + '/' + venue;
        fetch(compRpt, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setCompetitionList(result.data)
                    setShowTable(true)
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(result.message)
                    setShowTable(false)
                }
            })
    }

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Competitions Report</h4>
                                </div>
                                <hr className="mb-10" />
                            </div>
                            <div className="row">
                                {/* <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">State</label>
                                        <Select
                                            value={stateList.find(state => state.geographyId === stateId) ? {
                                                value: stateId,
                                                label: stateList.find(state => state.geographyId === stateId).geographyName
                                            } : null}
                                            onChange={async (e) => {
                                                setStateId(e.value);
                                                const distResponse = await func.listGeoDistrictByStateId(e?.value);
                                                setDistrictList(Array.isArray(distResponse) ? distResponse : [])
                                            }}
                                            required
                                            placeholder="Select State"
                                            options={stateList.map(state => ({
                                                value: state.geographyId,
                                                label: state.geographyName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">District</label>
                                        <Select
                                            value={districtList.find(district => district.geoDistrictsId === districtId) ? {
                                                value: districtId,
                                                label: districtList.find(district => district.geoDistrictsId === districtId).geoDistrictsName
                                            } : null}
                                            onChange={async (e) => {
                                                setDistrictId(e.value);
                                                const cityResponse = await func.listGeoCityByDistrictId(e?.value);
                                                setCityList(Array.isArray(cityResponse) ? cityResponse : [])
                                            }}
                                            required
                                            placeholder="Select District"
                                            options={districtList.map(district => ({
                                                value: district.geoDistrictsId,
                                                label: district.geoDistrictsName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">City</label>
                                        <Select
                                            value={cityList.find(city => city.geoCityId === cityId) ? {
                                                value: cityId,
                                                label: cityList.find(city => city.geoCityId === cityId).geoCityName
                                            } : null}
                                            onChange={async (e) => {
                                                setCityId(e.value);
                                                const cntrResponse = await func.listGeoCentersByCityId(e?.value);
                                                setCenterList(Array.isArray(cntrResponse) ? cntrResponse : [])
                                            }}
                                            required
                                            placeholder="Select City"
                                            options={cityList.map(city => ({
                                                value: city.geoCityId,
                                                label: city.geoCityName
                                            }))}>
                                        </Select>
                                    </div>
                                </div> */}
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Center</label>
                                        <Select
                                            value={centerList.find(center => center.geoCityId === centerId) ? {
                                                value: centerId,
                                                label: centerList.find(center => center.geoCityId === centerId).geoCityName
                                            } : null}
                                            onChange={async (e) => {
                                                setCenterId(e.value);
                                            }}
                                            required
                                            placeholder="Select Center"
                                            options={centerList.map(center => ({
                                                value: center.geoCityId,
                                                label: center.geoCityName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Competition Type</label>
                                        <Select
                                            value={competitionTypeList.find(compTyp => compTyp.competitionTypeId === competitionTypeId) ? {
                                                value: competitionTypeId,
                                                label: competitionTypeList.find(compTyp => compTyp.competitionTypeId === competitionTypeId).competitionTypeName
                                            } : null}
                                            onChange={async (e) => {
                                                setCompetitionTypeId(e.value);
                                                const sprtResponse = await func.competitionSportType(null);
                                                setSportTypeList(Array.isArray(sprtResponse) ? sprtResponse : [])
                                            }}
                                            required
                                            placeholder="Select Competition Type"
                                            options={competitionTypeList.map(compTyp => ({
                                                value: compTyp.competitionTypeId,
                                                label: compTyp.competitionTypeName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Sport Type</label>
                                        <Select
                                            value={sportTypeList.find(sprtTyp => sprtTyp.competitionSportsTypeId === sportTypeId) ? {
                                                value: sportTypeId,
                                                label: sportTypeList.find(sprtTyp => sprtTyp.competitionSportsTypeId === sportTypeId).SportTypeName
                                            } : null}
                                            onChange={async (e) => {
                                                setSportTypeId(e.value);
                                                const sportResponse = await func.competitionSport(null);
                                                setSportList(Array.isArray(sportResponse) ? sportResponse : [])
                                            }}
                                            required
                                            placeholder="Select Sport Type"
                                            options={sportTypeList.map(sprtTyp => ({
                                                value: sprtTyp.competitionSportsTypeId,
                                                label: sprtTyp.SportTypeName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Sports</label>
                                        <Select
                                            value={sportList.find(sprtTyp => sprtTyp.competitionsportsId === sportId) ? {
                                                value: sportId,
                                                label: sportList.find(sprtTyp => sprtTyp.competitionsportsId === sportId).sportName
                                            } : null}
                                            onChange={async (e) => {
                                                setSportId(e.value);
                                            }}
                                            required
                                            placeholder="Select Sport"
                                            options={sportList.map(sprtTyp => ({
                                                value: sprtTyp.competitionsportsId,
                                                label: sprtTyp.sportName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Venue</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="venue"
                                            placeholder="Enter Venue"
                                            required
                                            value={venue}
                                            onChange={(e) => setVenue(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-end">
                                <div className="col-lg-2 col-sm-12 mb-2">
                                    <Button
                                        type="button"
                                        variant="secondary"
                                        onClick={competitionsReport}
                                        className="w-100"
                                    >
                                        Submit
                                    </Button>
                                </div>

                                {/* <div className="col-lg-2 col-sm-12 mb-2">
                                    <Button
                                        type="button"
                                        variant="secondary"
                                        // onClick={exportToExcel} // ✅ Uncomment when function is ready
                                        className="w-100"
                                    >
                                        Export to Excel
                                    </Button>
                                </div> */}
                            </div>
                            <hr className="mb-10" />
                            {showTable && (
                                <div className="tab-content">
                                    <div className="col-lg-12 col-sm-12 mb-10 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="competitionTypeName"
                                                    header="Competition Type Name"
                                                    body={competitionTypeNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="competitionName"
                                                    header="Competition Name"
                                                    body={competitionNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="venue"
                                                    header="Venue"
                                                    body={venueRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="SportTypeName"
                                                    header="Sport Type Name"
                                                    body={sportTypeNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="sportName"
                                                    header="Sport Name"
                                                    body={sportNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="startDate"
                                                    header="Start Date"
                                                    body={startDateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="endDate"
                                                    header="End Date"
                                                    body={endDateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompetitionsReport;